import { Icon } from '@/icons/Icon'
import { useTranslation } from '@/i18n'

/**
 * Sidenav 足元の 3 点メニュー (popover 中身)。
 *
 * 役割: アカウント設定 / 今すぐロック / ログアウト + 利用規約・プライバシー リンク。
 * 表示制御 (open/close) と outside-click は親 (Sidenav) が責任を持つ。
 *
 * onSelect は 1 つのコールバックに集約: 親側で「メニューを閉じてから navigate する」
 * という流れを単一箇所で書けるようにする。
 */
export type SidenavFooterMenuTarget = 'settings/account' | 'lock' | 'logout' | 'terms' | 'privacy'

export interface SidenavFooterMenuProps {
  onSelect: (target: SidenavFooterMenuTarget) => void
}

export const SidenavFooterMenu = ({ onSelect }: SidenavFooterMenuProps): JSX.Element => {
  const { t } = useTranslation()

  return (
    <div className="foot-menu" role="menu">
      <button type="button" className="foot-menu-item" onClick={() => onSelect('settings/account')}>
        <Icon name="user" />
        {t('common.ui.account_settings')}
      </button>
      <button type="button" className="foot-menu-item" onClick={() => onSelect('lock')}>
        <Icon name="lock" />
        {t('common.ui.lock_now')}
      </button>
      <div className="foot-menu-divider" />
      <button type="button" className="foot-menu-item" onClick={() => onSelect('logout')}>
        <Icon name="logout" />
        {t('common.ui.logout')}
      </button>
    </div>
  )
}
